/* ============================================================
   Rizq by Design — Launch in a Day :: interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Countdown (resets to a rolling 47h window, persisted) ---------- */
  function initCountdown() {
    var KEY = 'ribd_launch_deadline';
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    var now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + (47 * 3600 + 12 * 60) * 1000; // ~47h12m
      localStorage.setItem(KEY, deadline);
    }
    var els = document.querySelectorAll('[data-countdown]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, deadline - Date.now());
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      els.forEach(function (root) {
        var set = function (sel, v) { var n = root.querySelector(sel); if (n) n.textContent = pad(v); };
        set('[data-h]', h + d * 24);
        set('[data-m]', m);
        set('[data-s]', s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Live viewer counter (gently fluctuates) ---------- */
  function initViewers() {
    var els = document.querySelectorAll('[data-viewers]');
    var n = 23;
    function render() { els.forEach(function (e) { e.textContent = n; }); }
    render();
    setInterval(function () {
      n += Math.round((Math.random() - 0.45) * 3);
      if (n < 17) n = 17; if (n > 31) n = 31;
      render();
    }, 4200);
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(function (o) {
          o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null;
        });
        if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---------- Sticky mobile CTA (after hero) ---------- */
  function initStickyCta() {
    var bar = document.querySelector('.sticky-cta');
    var hero = document.querySelector('.hero');
    if (!bar || !hero) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('show', !e.isIntersecting);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(hero);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Live social-proof popups ---------- */
  function initSocialProof() {
    var pop = document.getElementById('spPop');
    if (!pop) return;
    var avEl = pop.querySelector('.sp-av');
    var nameEl = pop.querySelector('[data-sp-name]');
    var actEl = pop.querySelector('[data-sp-act]');
    var agoEl = pop.querySelector('[data-sp-ago]');
    var closeBtn = pop.querySelector('.sp-close');
    var closed = false;

    var people = [
      { n: 'Aisha from Dubai', a: 'joined the system', t: '2 hours ago' },
      { n: 'Yusuf from Sharjah', a: 'joined today', t: 'just now' },
      { n: 'Fatima from Abu Dhabi', a: 'started the system', t: '14 minutes ago' },
      { n: 'Omar from Dubai', a: 'unlocked all 6 modules', t: '38 minutes ago' },
      { n: 'Maryam from Ajman', a: 'joined the community', t: '1 hour ago' },
      { n: 'Bilal from Al Ain', a: 'started building today', t: '3 hours ago' },
      { n: 'Khadija from Dubai', a: 'joined the launch offer', t: 'just now' },
      { n: 'Ibrahim from Sharjah', a: 'reserved a UAE spot', t: '22 minutes ago' }
    ];
    var i = Math.floor(Math.random() * people.length);

    function show() {
      if (closed) return;
      var p = people[i % people.length]; i++;
      nameEl.textContent = p.n;
      actEl.textContent = p.a;
      agoEl.textContent = p.t;
      pop.classList.add('show');
      setTimeout(function () { pop.classList.remove('show'); }, 5200);
    }
    closeBtn.addEventListener('click', function () { closed = true; pop.classList.remove('show'); });

    setTimeout(function loop() {
      show();
      setTimeout(loop, 12000 + Math.random() * 6000);
    }, 4500);
  }

  /* ---------- Spots-left bar (cosmetic urgency) ---------- */
  function initSpots() {
    var el = document.querySelector('[data-spots]');
    if (!el) return;
    var KEY = 'ribd_spots';
    var v = parseInt(localStorage.getItem(KEY), 10);
    if (!v || v < 6 || v > 19) { v = 14; localStorage.setItem(KEY, v); }
    el.textContent = v;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initViewers();
    initFaq();
    initStickyCta();
    initReveal();
    initSocialProof();
    initSpots();
  });
})();